(function() {
    const DEFAULT_DURATION = 2000;
    let container = null;
    function ensureContainer() {
      if (container && document.body.contains(container)) return container;
      container = document.createElement('div');
      container.id = 'global_message_container';
      container.className = 'global-message-container';
      document.body.appendChild(container);
      return container;
    }
    function createMessageEl(text, type) {
      const el = document.createElement('div');
      el.className = 'global-message';
      const typeClass = type === 'error' ? 'global-message-error' : 'global-message-success';
      el.classList.add(typeClass);
      // 文本
      const textEl = document.createElement('span');
      textEl.className = 'global-message-content';
      textEl.textContent = (text == null ? '' : String(text));
      el.appendChild(textEl);
      return el;
    }
    function normalizeOptions(options) {
      if (typeof options === 'string') {
        return { message: options, type: 'success', duration: DEFAULT_DURATION };
      }
      const opt = options || {};
      const type = (opt.type === 'error' || opt.type === 'success') ? opt.type : 'success';
      let duration = parseInt(opt.duration, 10);
      if (!(duration > 0)) duration = DEFAULT_DURATION;
      const message = opt.message != null ? String(opt.message) : '';
      return { message, type, duration };
    }
    function closeMessage(el) {
      if (!el) return;
      // 退出动画（通过类控制）
      el.classList.remove('is-show');
      const removeNode = () => {
        try { el.remove(); } catch(_) {}
        if (container && container.childElementCount === 0) {
          try { container.remove(); } catch(_) {}
          container = null;
        }
      };
      el.addEventListener('transitionend', removeNode, { once: true });
      setTimeout(removeNode, 300);
    }
    function Message(options) {
      try {
        const { message, type, duration } = normalizeOptions(options);
        const parent = ensureContainer();
        const el = createMessageEl(message, type);
        parent.appendChild(el);
        // 进场（通过类控制）
        requestAnimationFrame(() => {
          el.classList.add('is-show');
        });
        const timer = setTimeout(() => closeMessage(el), duration);
        return {
          close: () => { clearTimeout(timer); closeMessage(el); }
        };
      } catch (err) {
        console.error('Message error:', err);
        return { close: () => {} };
      }
    }
    window.CozyMessage = Message
    console.log("global-message 已经挂载-=====")
})()

;(function () {
  var accountCenterPath = '/pages/my-account-center?entry=automatic-account-routing-20260817-5'
  var accountCenterUrl = window.location.hostname === 'cozyology.com'
    ? 'https://www.cozyology.com' + accountCenterPath
    : accountCenterPath
  var accountEntrySelector = [
    '[data-cz-account-center-entry]',
    'a.header-account-link',
    'button.header-account-link',
    'a[aria-label="Account"]',
    'button[aria-label="Account"]',
    'a[aria-label="Customer account"]',
    'button[aria-label="Customer account"]',
    'a[aria-label="账户"]',
    'button[aria-label="账户"]',
    'a[href="/account"]',
    'a[href="/account/"]',
    'a[href^="/account?"]',
    'a[href="https://account.cozyology.com"]',
    'a[href="https://account.cozyology.com/"]',
    'a[href^="https://account.cozyology.com?"]',
    'a[href="https://account.cozyology.com/orders"]',
    'a[href^="https://account.cozyology.com/orders?"]'
  ].join(', ')

  function isExcludedAccountEntry(link) {
    var href = link && link.getAttribute ? (link.getAttribute('href') || '') : ''
    return /wishlist|logout/i.test(href)
  }

  function routeAccountEntries(root) {
    var scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll(accountEntrySelector).forEach(function (link) {
      if (isExcludedAccountEntry(link)) return
      link.setAttribute('href', accountCenterUrl)
      link.setAttribute('data-cz-account-center-entry', 'true')
      if (link.dataset.czAccountRouteBound === '1') return
      link.dataset.czAccountRouteBound = '1'
      link.addEventListener('click', function (event) {
        event.preventDefault()
        window.location.assign(accountCenterUrl)
      }, true)
    })
  }

  routeAccountEntries(document)
  document.addEventListener('DOMContentLoaded', function () {
    routeAccountEntries(document)
  })
  new MutationObserver(function () {
    routeAccountEntries(document)
  }).observe(document.documentElement, { childList: true, subtree: true })
})()
